import axios from 'axios';
import { baseURL } from './APIService';

import { ScenarioParameterTemplateModelDTO } from '../Models/ScenarioParameterTemplateModel';
import { ScenarioParameterModelDTO } from '../Models/ScenarioParameterModel';
import { ScenarioModelDTO } from '../Models/ScenarioModel';


export const getDataset = async (datasetId: string) => {
  const response = await axios.get<any>(baseURL + 'dataset/get/' + datasetId);
  return response.data as any;
};


export const getETL = async (ETLId: string) => {
  const response = await axios.get<any>(baseURL + 'dataset/getETL/' + ETLId);
  return response.data as any;
};

export const getScenarios = async (projectId: string) => {
  const response = await axios.get<ScenarioModelDTO[]>(baseURL + 'scenario/project/' + projectId);
  return response.data as any;
};

export const getScenarioBatches = async (project_id:any) => {
  const response = await axios.get<ScenarioModelDTO[]>(baseURL + 'scenarioBatch/project/' + project_id);
  return response.data as any;
};

export const getScenarioRuns = async (id: string) => {
  const response = await axios.get<any>(baseURL + 'scenario/' + id + '/run');
  return response.data as any;
};

export const getScenario = async (id: string) => {
  const response = await axios.get<any>(baseURL + 'scenario/' + id);
  return response.data as any;
};

export const getScenarioOutput_kpis = async () => {
  const response = await axios.get<ScenarioModelDTO[]>(baseURL + 'ScenarioRunKPI/get');
  return response.data as any;
};

export const postScenario = async (
  id: string,
  label: string,
  description: string,
  modelId: string,
  inputDatasets: string[],
  supplychains: string[],
  parameters: ScenarioParameterModelDTO[],
  dataCombinationPolicy: string,
  batchId: string
) => {
  const response = await axios.post(baseURL + 'scenario', {
    id: id,
    label: label,
    description: description,
    model_id: modelId,
    input_datasets: inputDatasets,
    supplychains: supplychains,
    parameters: parameters,
    data_combination_policy: dataCombinationPolicy,
    batch_id: batchId
  });
  return response.data as any;
};

export const postScenarioBatch = async (
  label: string,
  description: string,
  projectId: string,
  modelId: string,
  tags: string[],
  parameters: any[],
  inputDatsets: string[],
  inputSupplychains: string[],
  dataCombinationPolicy: string
) => {
  const response = await axios.post(baseURL + 'scenarioBatch', {
    label: label,
    description: description,
    project_id: projectId,
    modelId: modelId,
    tags: tags,
    parameters: parameters,
    inputDatasets: inputDatsets,
    inputSupplychains: inputSupplychains,
    dataCombinationPolicy: dataCombinationPolicy
  });
  return response.data as any;
};

export const postDispatchScenarioRun = async (
  scenarioId: string,
  projectId: string,
  model: string,
  replications: number
) => {
  const response = await axios.post(baseURL + 'scenario/dispatch', {
    scenario_id: scenarioId,
    project_id: projectId,
    model: model,
    replications: replications
  });
  return response.data as any;
};

export const postDuplicateScenario = async (scenarioId: string) => {
  const response = await axios.post(baseURL + 'scenario/duplicate', {
    scenario_id: scenarioId
  });
  return response.data as any;
};

export const postDeleteScenario = async (scenarioId: string) => {
  const response = await axios.post(baseURL + 'scenario/delete', {
    scenario_id: scenarioId
  });
  return response.data as any;
};

export const postBaselineScenario = async (scenarioId: string, projectId: string) => {
  const response = await axios.post(baseURL + 'scenario/baseline', {
    scenario_id: scenarioId,
    project_id: projectId
  });
  return response.data as any;
};

export const postEditScenario = async (
  id: string,
  label: string,
  description: string,
  creationTimestamp: string,
  createdBy: string,
  modifiedTimestamp: string,
  modifiedBy: string,
  lineage: string,
  type: string,
  modelId: string,
  tags: string[],
  startDate: string,
  inputData: string[],
  publicScenario: boolean
) => {
  const response = await axios.post(baseURL + 'scenario/edit/' + id, {
    id: id,
    label: label,
    description: description,
    creation_timestamp: creationTimestamp,
    created_by: createdBy,
    modified_timestamp: modifiedTimestamp,
    modified_by: modifiedBy,
    lineage: lineage,
    type: type,
    model_id: modelId,
    tags: tags,
    startDate: startDate,
    inputData: inputData,
    public: publicScenario
  });
  return response.data as any;
};

export const postEditScenarioTags = async (scenarioId: string, tags: string[]) => {
  const response = await axios.post(baseURL + 'scenario/editTags/' + scenarioId, {
    tags: tags
  });
  return response.data as any;
};

export const getScenarioParameterTemplates = async () => {
  const response = await axios.get<any>(baseURL + 'scenarioParameterTemplate');

  return response.data as any[];
};

export const getScenarioParameterTemplate = async (id: string) => {
  const response = await axios.get<any>(baseURL + 'scenarioParameterTemplate/' + id);
  return response.data as any;
};

export const postScenarioParameterTemplates = async (data: ScenarioParameterTemplateModelDTO[]) => {
  let newdata = data.map((d: ScenarioParameterTemplateModelDTO) => {
    return {
      id: d.id,
      name: d.name,
      display_name: d.displayName,
      data_type: d.dataType,
      help_string: d.helpString,
      validation_rules: d.validationRules,
      model_id: d.modelId,
      generate_batch: d.generateBatch,
      required: d.required
    };
  });
  const response = await axios.post(baseURL + 'scenarioParameterTemplate', newdata);
  return response.data as any;
};

export const postGenerateScenarioRunInput = async (
  inputDatasets: string[],
  supplychains: string[],
  parameters: ScenarioParameterModelDTO[],
) => {
  const response = await axios.post(baseURL + 'scenario/run/input', {
    input_datasets: inputDatasets,
    input_supplychain: supplychains,
    parameters: parameters,
  });
  return response.data as any;
};

export const postEditRunInput = async (id: string, body: any) => {
  const response = await axios.post(baseURL + 'scenario/edit/runinput/' + id, {
    ...body
  });
  return response.data as any;
};
